import { createAsyncThunk } from '@reduxjs/toolkit';
import { getKanbanTickets } from '../services/getKanbanTickets.service';

export const loadKanbanTickets = createAsyncThunk(
  'kanban/loadKanbanTickets',
  async (projectId) => {
    const response = await getKanbanTickets(projectId);
    return response;
  }
);
